export default "__VITE_ASSET__CpJikHAw__"